import { withTranslatedMeta } from 'i18n/utils'

import { dashboardViewSelector } from '../selectors'
import featureToggles from 'shared/featureToggles'
import ReservationsList from './ReservationsList'
import MyAccountBlock from './MyAccountBlock'
import News from './News'
import Contact from './Contact'

const DashboardView = ({ contactUsBackground, infoBackground }) => (
    <div className="no-gutters">
        <ReservationsList />
        <News />
        <div className="dashboard-main-tab-container dashboard-inner-container col-md-9">
            {featureToggles.showAllExceptCanada && <MyAccountBlock background={infoBackground} />}
            {featureToggles.showAllExceptCanada && <Contact background={contactUsBackground} />}
        </div>
    </div>
)

export default compose(withTranslatedMeta('dashboard.menu.index'), connect(dashboardViewSelector))(DashboardView)
